import {
    CICLOS_ESCOLARES,
    DEPARTAMENTOS,
    PLANES_ESTUDIO,
    INFO,
    CONJUNTO_PERIODOS,
    LABELS,
    ESTRUCTURA_CUSTOMNAMES,
    PARAMETROS
} from '../constants/Sistema';

export function DptosAcademicos(dptos) {
  return {
    type: DEPARTAMENTOS,
    dptos
  };
}


export function CiclosEscolares(ciclos) {
    return {
      type: CICLOS_ESCOLARES,
      ciclos
    };
}

export function InfoGeneral(info) {
  return {
    type: INFO,
    info
  };
}

export function PlanesEstudio(planes) {
  return {
    type: PLANES_ESTUDIO,
    planes
  };
}
  
export function ConjuntoPeriodos(conjuntoPeriodos){
  return {
    type: CONJUNTO_PERIODOS,
    conjuntoPeriodos
  };
}

export function Labels(labels){
  return {
    type: LABELS,
    labels
  };
}

export function EstructuraCustomNames(customNames){
  return {
    type: ESTRUCTURA_CUSTOMNAMES,
    customNames
  };
}

export function SetParametros(parametros){
  return {
    type: PARAMETROS,
    parametros
  };
}



